import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DeleteModal } from "shared/components";
import { dataMetaSelector, deleteEventGuest, dispatchGetEventGuests } from "Bands/state";
import { useClearActionMetaOnUnMount } from "Bands/utils";
import { BAND_ACTIONS, IEventGuest } from "Bands/types";
import { IAPIState, IStatus } from "shared/types";
import { addTemporaryToast } from "shared/components/Toast";
import { copy } from "shared/assets";

const deleteCopy = copy.guestlistBlock.guests.delete;

interface DeleteGuestModalProps {
  guest: IEventGuest;
  blockId: string;
  handleClose: () => void;
}

export const DeleteGuestModal: React.FC<DeleteGuestModalProps> = ({
  guest: { id: guestId, firstname, lastname },
  blockId,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deleteEventGuest));
  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteEventGuest);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleClose();

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: deleteCopy.messages.success,
        })
      );

      dispatchGetEventGuests({ dispatch, blockId });
    }
  }, [apiMeta?.status, blockId, dispatch, handleClose]);

  const handleDelete = () => {
    dispatch(deleteEventGuest({ id: guestId, blockId }));
  };

  return (
    <DeleteModal
      name={`${firstname} ${lastname}`}
      type="guest"
      dataTestId="guest_delete_modal"
      apiMeta={apiMeta}
      handleClose={handleClose}
      handleDelete={handleDelete}
    />
  );
};
